import { MonthlyReportIndex } from './../../../models/monthly-report.model';
import { PoolTypes, WeeklyReportResponse } from './../../../models/weekly-report.model';
import { DashboardService, DashboardStats, StatusStats } from '../../../services/dashboard.service';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from '../../../material.module';
import { FormsModule } from '@angular/forms';
import { WeeklyReportService } from '../../../services/weekly-report.service';
import { ModalSnackbarService } from '../../../services/modal-snackbar.service';
import { firstValueFrom } from 'rxjs';
import { getAdToYm, getNextAd, getPrevAd, truncateDecimals } from '../../../misc/functions';
import { DecimalInputComponent } from '../../common/decimal-input.component';
import { bcadd, bccomp, bcdiv, bcmul, RoundMode } from '../../../misc/bcmath';
import { MonthlyReportService } from '../../../services/monthly-report.service';

@Component({
  selector: 'app-admin-weekly-report',
  standalone: true,
  imports: [CommonModule, RouterModule, MaterialModule, FormsModule, DecimalInputComponent],
  templateUrl: './admin-weekly-report.component.html',
  styleUrls: ['./admin-weekly-report.component.scss']
})
export class AdminWeeklyReportComponent implements OnInit {
  isLoaded = false;

  currentAd: number = 0;
  prevAd: number = 0;
  nextAd: number = 0;

  poolTypes = PoolTypes;

  periodIndex = [0, 1, 2, 3];

  data?: WeeklyReportResponse;

  monthly?: MonthlyReportIndex;

  constructor(
    private router: Router,
    private monthlyService: MonthlyReportService,
    private weeklyService: WeeklyReportService,
    private snackBar: ModalSnackbarService,
  ) {}

  ngOnInit(): void {
    this.initialLoad();
  }

  async initialLoad() {
    const ad = await firstValueFrom(this.weeklyService.getLatestAd(true));
    this.changeAd(ad);
    this.isLoaded = true;
  }

  get ym() {
    return getAdToYm(this.currentAd);
  }

  changeAd(ad: number) {
    this.data = undefined;
    this.currentAd = ad;
    this.prevAd = getPrevAd(ad);
    this.nextAd = getNextAd(ad);

    // 月報データがあったら週報の為替レートは変更できない
    this.monthly = undefined;
    this.monthlyService.getAdminIndex(ad).subscribe({
      next: (res) => {
        this.monthly = res;
      },
      error: () => this.snackBar.show('月報の読み込み失敗')
    })

    this.weeklyService.getAll(ad, true, true).subscribe({
      next: (res) => {
        this.data = res;

        // data[4] の meta がカラだったらセット
        const row = this.data[4];
        if (row && !row.meta) {
          this.data[4].meta = {
            CHFJPY: '',
            USDJPY: '',
            AUDJPY: '',
            GBPJPY: '',
            EURJPY: '',
          };
        }

      },
      error: () => this.snackBar.show('週報の読み込み失敗')
    });

  }

  save() {
    if (this.data) {

      this.data[4].is_public = this.data[3].is_public = this.data[2].is_public = this.data[1].is_public = this.data[0].is_public;

      this.weeklyService.store(this.data).subscribe({
        next: () => {
          this.snackBar.show('保存しました');
        },
        error: () => {
          this.snackBar.show('保存に失敗しました');
        }
      });
    }
  }

  calc(type: string) {
    if (!this.data) return;
    if (bccomp(this.data[4].reports[type].beginning_balance, '0') === 0) return;

    const balance = this.data[4].reports[type].beginning_balance;

    let sum_trade = '0';
    let sum_swap = '0';

    for(let idx = 0; idx <= 3; idx++) {
      this.data[idx].reports[type].trade_per = bcdiv(bcmul(this.data[idx].reports[type].trade_profit, 100), balance);
      this.data[idx].reports[type].swap_per = bcdiv(bcmul(this.data[idx].reports[type].swap_profit, 100), balance);

      this.data[idx].reports[type].sum_profit = bcadd(this.data[idx].reports[type].trade_profit, this.data[idx].reports[type].swap_profit);
      this.data[idx].reports[type].sum_per = bcdiv(bcmul(this.data[idx].reports[type].sum_profit, '100'), balance);

      sum_trade = bcadd(sum_trade, this.data[idx].reports[type].trade_profit);
      sum_swap = bcadd(sum_swap, this.data[idx].reports[type].swap_profit);
    }

    this.data[4].reports[type].trade_profit = bcadd(sum_trade, '0');
    this.data[4].reports[type].swap_profit = bcadd(sum_swap, '0');
    this.data[4].reports[type].sum_profit = bcadd(sum_trade, sum_swap);

    this.data[4].reports[type].trade_per = bcdiv(bcmul(sum_trade, '100'), balance);
    this.data[4].reports[type].swap_per = bcdiv(bcmul(sum_swap, '100'), balance);
    this.data[4].reports[type].sum_per = bcdiv(bcmul(bcadd(sum_trade, sum_swap), '100'), balance);
  }

  calcMonth(type: string) {
    if (!this.data) return;
    if (bccomp(this.data[4].reports[type].beginning_balance, '0') === 0) return;

    const balance = this.data[4].reports[type].beginning_balance;

    this.data[4].reports[type].sum_profit = bcadd(this.data[4].reports[type].trade_profit, this.data[4].reports[type].swap_profit);

    this.data[4].reports[type].trade_per = bcdiv(bcmul(this.data[4].reports[type].trade_profit, '100'), balance);
    this.data[4].reports[type].swap_per = bcdiv(bcmul(this.data[4].reports[type].swap_profit, '100'), balance);
    this.data[4].reports[type].sum_per = bcdiv(bcmul(this.data[4].reports[type].sum_profit, '100'), balance);

  }
}
